import { IBaseArgument } from './IBaseArgument';
import { BaseResponseBuilder } from './BaseResponseBuilder';

export class PaxRequirementResponseBuilder extends BaseResponseBuilder {
    constructor() {
        super('PaxRequirement');
    }
    public withId = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['id'] = this.initField(null, args);
        return this;
    }

    public withCode = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['code'] = this.initField(null, args);
        return this;
    }

    public withMinAge = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['minAge'] = this.initField(null, args);
        return this;
    }

    public withMaxAge = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['maxAge'] = this.initField(null, args);
        return this;
    }

    public withMinPax = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['minPax'] = this.initField(null, args);
        return this;
    }

    public withMinPaxWhenSelected = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['minPaxWhenSelected'] = this.initField(null, args);
        return this;
    }

    public withMaxPax = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['maxPax'] = this.initField(null, args);
        return this;
    }

    public withPaxIncrementalStep = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['paxIncrementalStep'] = this.initField(null, args);
        return this;
    }
}
